<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">گراف {{ lessonTitle }}</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>
    <div class="p-3">
      <div v-if="loading" class="text-center mt-5">
        <p>در حال دریافت معلومات گراف...</p>
      </div>
      <div v-else-if="!chartData.datasets[0].data || chartData.datasets[0].data.length === 0" class="text-center mt-5 text_color_gray">
        داده‌ای برای نمایش گراف وجود ندارد.
      </div>
      <div v-else class="bg_white rounded-4 p-3 shadow-sm">
        <div class="chart-scroll-container">
          <div class="chart-wrapper" :style="{ width: dynamicChartWidth }">
            <Line :data="chartData" :options="chartOptions" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import { Line } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

export default {
  name: 'LessonChartView',
  components: { Line },
  data() {
    return {
      loading: false,
      lessonId: null,
      lessonTitle: '',
      dataPointsCount: 0,
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'نمره',
            backgroundColor: '#4A00E0',
            borderColor: '#4A00E0',
            data: [],
            tension: 0.4,
            fill: false,
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              font: {
                size: 16,
                family: 'inherit'
              },
              padding: 20
            }
          }
        },
        scales: {
          x: {
            ticks: {
              maxRotation: 90,
              minRotation: 90,
              autoSkip: false,
              font: {
                size: 11
              }
            }
          },
          y: {
            beginAtZero: true,
            max: 100
          }
        },
        elements: {
          point: {
            radius: 6,
            hoverRadius: 8,
            backgroundColor: '#4A00E0'
          }
        },
        layout: {
          padding: {
            bottom: 10
          }
        }
      }
    }
  },
  computed: {
    dynamicChartWidth() {
      const widthPerPoint = 50;
      const calculatedWidth = this.dataPointsCount * widthPerPoint;
      return calculatedWidth > window.innerWidth ? `${calculatedWidth}px` : '100%';
    }
  },
  mounted() {
    this.lessonId = this.$route.params.lessonId;
    this.lessonTitle = this.$route.query.lessonTitle || '';
    if (this.lessonId) {
      this.fetchChartDetails();
    }
  },
  methods: {
    async fetchChartDetails() {
      this.loading = true;
      try {
        const userId = localStorage.getItem('user_id');
        const formData = createFormData({
          user_id: userId,
          lesson_id: this.lessonId
        });

        const response = await apiClient.post('/chart_lessons_details', formData);
        
        if (response.data.status === 'ok' && response.data.data) {
          const points = response.data.data.points || [];
          this.lessonTitle = response.data.data.lesson_title || this.lessonTitle;
          this.dataPointsCount = points.length;
          
          this.chartData.labels = points.map(p => p.date);
          this.chartData.datasets[0].data = points.map(p => p.score);
        }
      } catch (error) {
        console.error("Error fetching chart details:", error);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.chart-scroll-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch; 
}
.chart-wrapper {
  height: 400px;
  position: relative;
}
</style>